import { createSlice } from "@reduxjs/toolkit";

const messageSlice = createSlice({
	name: "message",
	initialState: {
		receivedNewMessages: false,
	},
	reducers: {
		setReceivedNewMessages(state, action) {
			state.receivedNewMessages = action.payload;
		},
	},
});

export const { setReceivedNewMessages } = messageSlice.actions;

export default messageSlice.reducer;
